/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderInlineDataFragment } from "relay-runtime";
import {  } from "relay-runtime";
export type bidModalTrackingHelpers_item = {
    readonly serviceId: string | null;
    readonly relevantAuctionSolution: {
        readonly minNextBidAmount: {
            readonly amount: number | null;
        } | null;
    } | null;
    readonly " $refType": "bidModalTrackingHelpers_item";
};
export type bidModalTrackingHelpers_item$data = bidModalTrackingHelpers_item;
export type bidModalTrackingHelpers_item$key = {
    readonly " $data"?: bidModalTrackingHelpers_item$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"bidModalTrackingHelpers_item">;
};



const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "bidModalTrackingHelpers_item"
};
(node as any).hash = 'ed2dc3a6e0f320d48cf29c3a0d257a4e';
export default node;
